const strMap = '0123456789abcdefghijklmnopqrstuvwxyz'

export function uid(str = '', len = 6) {
  if (str.length > 0) str += '_'
  while (len--) str += strMap[(Math.random() * 36) | 0]
  return str
}
